import React, { useEffect, useMemo, useRef, useState } from 'react';
import classNames from 'classnames';
import css from './styles.module.scss';
import { StepControls } from '~/common/step-controls';
import { useSelector } from 'react-redux';
import { selectNewDeal, selectUserData } from '~/features/dashboard/store/selectors';
import { useForm, Controller } from 'react-hook-form';
import { createContact, createNewDealStepThreeThunk } from '~/features/dashboard/store/actions.thunks';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { Button, Typography, TextField, Grid, Box, Paper, Avatar } from '@material-ui/core';
import CreatableSelect from 'react-select/creatable';
import { useRouteMatch } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import { each, find } from 'lodash';
import { getContactsThunk } from '~/features/dashboard/store/actions.thunks';
import { User } from '~/store/user/models';
import { DealInput } from '../deal-input';
import { ProfileInput } from '~/features/dashboard/components/profile-input';
import EditIcon from '@material-ui/icons/Edit';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import { VerticalPopver } from '~/features/dashboard/components/vertical-popover';

interface Step_3Props {
    prevStep: () => void;
}

export const Step_3: React.FC<Step_3Props> = ({ prevStep }) => {
    const [legalUserList, setLegalUserList] = useState<any[]>([]);
    const [companyUserList, setCompanyUserList] = useState<any[]>([]);
    const newDealState = useSelector(selectNewDeal);
    const match = useRouteMatch<{ creatorId: string }>();
    const Users = useSelector(selectUserData);
    const dispatch = useThunkDispatch();

    const [legalEntityData, setLegalEntityData] = useState({
        name: '',
        image: '',
    });
    const [companyEntityData, setCompanyEntityData] = useState({
        name: '',
        dealCompany: '',
        image: '',
    });


    const [isReverse, setIsReverse] = useState(false);
    const [isEditForm, setIsEditForm] = useState(false);
    const [isUserEditAddress, setIsUserEditAddress] = useState(false);
    const [isCompanyEditAddress, setIsCompanyEditAddress] = useState(false);
    const [imageFileUser, setImageFileUser] = useState<any>();
    const [imageFileCompany, setImageFileCompany] = useState<any>();

    const editContactForm = () => {
        setIsEditForm(true);
    };

    const cancelForm = () => {
        setIsEditForm(false);
    };

    const editAddressForm = () => {
        setIsUserEditAddress(true);
    };

    const cancelAddressForm = () => {
        setIsUserEditAddress(false);
    };

    const editCompanyAddressForm = () => {
        setIsCompanyEditAddress(true);
    };

    const cancelCompanyAddressForm = () => {
        setIsCompanyEditAddress(false);
    };

    const elementFocus = (ref: any) => {
        // if (ref) {
        //     ref.current.focus();
        // }
    };

    const updateData = (name: string, value: any) => {
        // if (name) {
        //     setUserProfile({ ...userProfile, [name]: value });
        // }
    };

    const [countryCode, setCountryCode] = useState('');
    const [countryCodeForUser, setCountryCodeForUser] = useState('');
    const [newLegalEntity, setNewLegalEntity] = useState<any>(null);
    const [newCompanyContact, setNewCompanyContact] = useState<any>(null);

    useEffect(() => {
        if (Users) {
            let legalUser = Users.contacts.filter((person: User) => {
                const typeExists = typeof person.contactType === 'number';
                return (typeExists && [0, 8].includes(person.contactType as number)) || person.contactTypeDesc === 'My Legal Entity';
            });
            setLegalUserList(legalUser);

            let companyUsers = Users.contacts.filter((person: User) => person.contactTypeDesc === 'My Deal Contact');
            setCompanyUserList(companyUsers);
        }
    }, [Users]);

    const {
        handleSubmit,
        register,
        errors,
        setValue,
        formState: { isDirty },
        control,
        getValues,
    } = useForm<any>({
        defaultValues: {
            dealCompany: '',
            address1: '',
            address2: '',
            address3: '',
            address4: '',
            contractFirst: newDealState?.contractFirst || '',
            contractLast: '',
            contractPostCode: '',
            contractEmail: '',
            contractTelephone: '',
            address1forUser: '',
            address2forUser: '',
            address3forUser: '',
            address4forUser: '',
            contractFirstforUser: '',
            contractLastforUser: '',
            contractPostCodeforUser: '',
            contractEmailforUser: '',
            contractTelephoneforUser: '',
            imageUser: '',
            imageCompany: '',
            nameforUser: '',
            gDealId: newDealState?.contractRefNum || '',
            isNewEntry: false,
            companyNewEntry: false,
        },
    });
    useEffect(() => {
        const legaluserData = Users?.contacts?.find(
            (person: any) => person.userId === newDealState?.legalEntityId || person.contactCode === newDealState?.contractLegalContact
        );
        const companyUser = Users?.contacts?.find((person: any) => person.userId === newDealState?.companyContactId);

        if (legaluserData) {
            setValue('address1forUser', legaluserData.address);
            setValue('legalCompany', legaluserData.companyName);
            setValue('address2forUser', legaluserData.route);
            setValue('address3forUser', legaluserData.cityName);
            setValue('address4forUser', legaluserData.countryName);
            setValue('contractTelephoneforUser', legaluserData.phone);
            setValue('contractEmailforUser', legaluserData.email);
            setValue('contractFirstforUser', legaluserData.firstName);
            setValue('contractPostCodeforUser', legaluserData.zipCode);
            setValue('contractLastforUser', legaluserData.lastName);
            setValue('nameforUser', getContactName(legaluserData));
            setValue('isNewEntry', false);
            setValue('konAddIdforUser', legaluserData.konAddId);
            setNewLegalEntity(legaluserData.contactCode);
            setLegalEntityData({
                name: getContactName(legaluserData),
                image: legaluserData.image || '',
            });
        }

        if (companyUser) {
            setValue('address1', companyUser?.address);
            setValue('address2', companyUser?.route);
            setValue('address3', companyUser?.cityName);
            setValue('address4', companyUser?.countryName);
            setValue('companyName', companyUser?.companyName);
            setValue('dealCompany', newDealState?.contractCompany || '');
            setValue('contractTelephone', companyUser?.phone);
            setValue('contractEmail', companyUser?.email);
            setValue('contractFirst', companyUser?.firstName);
            setValue('contractPostCode', companyUser?.zipCode);
            setValue('contractLast', companyUser?.lastName);
            setNewCompanyContact(companyUser?.contactCode);
            setValue('companyNewEntry', false);
            setValue('konAddId', companyUser?.konAddId);
            setCompanyEntityData({
                image: companyUser?.image,
                name: getCompanyName(companyUser),
                dealCompany: getContactName(companyUser),
            });
        }
        setValue('gDealId', newDealState?.contractRefNum);
    }, [newDealState?.contractRefNum, Users]); // eslint-disable-line react-hooks/exhaustive-deps

    const onSubmit = async (data: any) => { // eslint-disable-line
        let tempObj: any = data;
        let newLegalEntityData = '';
        let newCompanyContactData = '';
        if (newLegalEntity) {
            newLegalEntityData = newLegalEntity;
        }
        if (newCompanyContact) {
            newCompanyContactData = newCompanyContact;
        }
        clean(tempObj);
        if (tempObj.isNewEntry === 'true') {
            let data1: any = {
                FIRST_NAME: tempObj.contractFirstforUser,
                LAST_NAME: tempObj.contractLastforUser,
                PHONE: tempObj.contractTelephoneforUser,
                EMAIL: tempObj.contractEmailforUser,
                DESCRIPTION: '',
                konAddId: tempObj.konAddIdforUser,
                addressLine1: tempObj.address1forUser,
                addressLine2: tempObj.address2forUser,
                addressLine3: tempObj.address3forUser,
                addressLine4: tempObj.address4forUser,
                country: tempObj.address4forUser,
                route: tempObj.address2forUser,
                locality: tempObj.address3forUser,
                postal_code: tempObj.contractPostCodeforUser,
                COMPANY_NAME: tempObj.legalCompany,
                ROLE: '8',
                IMAGE: [],
                CREATOR_ROLE: '',
                CREATOR_FULL_NAME: '',
            };
            let data_api = await dispatch(
                createContact({ ...data1, creatorId: match.params.creatorId, contactId: 0, contactCode: '', kontactId: 0, creatorCode: '' })
            );
            await dispatch(getContactsThunk({ creatorId: Number(match.params.creatorId) }));

            if (data_api.data.kontactCode) {
                setNewLegalEntity(data_api.data.kontactCode);
                newLegalEntityData = data_api.data.kontactCode;
            }
        }

        if (tempObj.companyNewEntry === 'true') {
            let data1: any = {
                FIRST_NAME: tempObj.contractFirst,
                LAST_NAME: tempObj.contractLast,
                PHONE: tempObj.contractTelephone,
                EMAIL: tempObj.contractEmail,
                DESCRIPTION: '',
                konAddId: tempObj.konAddId,
                addressLine1: tempObj.address1,
                addressLine2: tempObj.address2,
                addressLine3: tempObj.address3,
                addressLine4: tempObj.address4,
                country: tempObj.address4,
                route: tempObj.address2,
                locality: tempObj.address3,
                postal_code: tempObj.contractPostCode,
                ROLE: '11',
                IMAGE: [],
                CREATOR_ROLE: '',
                CREATOR_FULL_NAME: '',
                COMPANY_NAME: tempObj.companyName,
            };
            let data_company = await dispatch(
                createContact({ ...data1, creatorId: match.params.creatorId, contactId: 0, contactCode: '', kontactId: 0, creatorCode: '' })
            );
            await dispatch(getContactsThunk({ creatorId: Number(match.params.creatorId) }));

            if (data_company.data.kontactCode) {
                setNewCompanyContact(data_company.data.kontactCode);
                newCompanyContactData = data_company.data.kontactCode;
            }
        }
        dispatch(createNewDealStepThreeThunk({ ...data, creatorId: match.params.creatorId, newLegalEntityData, newCompanyContactData, isDirty }));
    };
    const resetFormLegal = () => {
        setValue('legalCompany', '');
        setValue('address1forUser', '');
        setValue('address2forUser', '');
        setValue('address3forUser', '');
        setValue('address4forUser', '');
        setValue('contractFirstforUser', '');
        setValue('contractLastforUser', '');
        setValue('contractPostCodeforUser', '');
        setValue('contractEmailforUser', '');
        setValue('contractTelephoneforUser', '');
        (document.getElementById('autocompleteforUser') as HTMLInputElement).value = '';
        setNewLegalEntity('');
        setLegalEntityData({
            name: '',
            image: '',
        });
    };
    const resetForm = () => {
        setValue('dealCompany', '');
        setValue('companyName', '');
        setValue('address1', '');
        setValue('address2', '');
        setValue('address3', '');
        setValue('address4', '');
        setValue('contractFirst', '');
        setValue('contractLast', '');
        setValue('contractPostCode', '');
        setValue('contractEmail', '');
        setValue('contractTelephone', '');
        setValue('nameforUser', '');
        setNewCompanyContact('');
        (document.getElementById('autocomplete1') as HTMLInputElement).value = '';
        setCompanyEntityData({
            dealCompany: '',
            name: '',
            image: '',
        });
    };

    useEffect(() => {
        newDealState?.contractCompany &&
            setCompanyEntityData({
                ...companyEntityData,
                dealCompany: newDealState.contractCompany,
                image: Users?.contacts?.find((person: any) => Number(person.userId) === Number(newDealState?.companyContactId))?.image || '',
            });
    }, [newDealState]); // eslint-disable-line react-hooks/exhaustive-deps
    const formSubmit = useMemo(() => handleSubmit(onSubmit), [handleSubmit, onSubmit]);

    function clean(obj: any) {
        var propNames = Object.getOwnPropertyNames(obj);
        for (var i = 0; i < propNames.length; i++) {
            var propName = propNames[i];
            if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
                delete obj[propName];
            }
        }
    }

    // Google api places autocomplete
    const autocomplete = useRef<google.maps.places.Autocomplete>();
    const autocomplete1 = useRef<google.maps.places.Autocomplete>();
    const fillOutFormWithGooglePlace = (placeResponse: google.maps.GeocoderAddressComponent[], inputPostfix: string = '') => {
        const fieldMapping: { [formField: string]: string[] } = {
            address1: ['street_number', 'route', 'neighborhood', 'premise', 'sublocality_level_1', 'sublocality_level_2'],
            address2: ['locality', 'postal_town'],
            address3: ['administrative_area_level_1', 'administrative_area_level_2'],
            address4: ['country'],
            contractPostCode: ['postal_code'],
        };

        if (placeResponse.find(item => item.short_name === 'GB' || item.short_name === 'LT')) {
            fieldMapping['address3'] = ['administrative_area_level_2'];
        }

        each(fieldMapping, (addressComponentNames, fieldName) => {
            const newValue = addressComponentNames
                .map(addressComponentName => {
                    const foundComponent = find(placeResponse, component => {
                        if (component.types[0] === 'country') {
                            if (inputPostfix === 'forUser') {
                                setCountryCodeForUser(component.short_name);
                            } else {
                                setCountryCode(component.short_name);
                            }
                        }
                        return component.types[0] === addressComponentName;
                    });
                    return foundComponent ? foundComponent[fieldName === 'contractPostCode' ? 'short_name' : 'long_name'] : null;
                })
                .filter(value => !!value)
                .join(', ');

            setValue(`${fieldName}${inputPostfix}`, newValue);
        });
    };

    function fillInAddress() {
        if (!autocomplete.current) return;
        // Get the place details from the autocomplete object.
        const place = autocomplete.current.getPlace();
        place.address_components && fillOutFormWithGooglePlace(place.address_components, 'forUser');
    }

    function fillInAddress1() {
        if (!autocomplete1.current) return;
        // Get the place details from the autocomplete object.
        const place = autocomplete1.current.getPlace();

        // Get each component of the address from the place details,
        // and then fill-in the corresponding field on the form.
        // TODO: probably needs to be re-ordered
        place.address_components && fillOutFormWithGooglePlace(place.address_components);
    }

    function initAutocomplete() {
        // Create the autocomplete object, restricting the search predictions to
        // geographical location types.

        autocomplete.current = new window.google.maps.places.Autocomplete(document.getElementById('autocompleteforUser') as HTMLInputElement, {
            types: ['geocode'],
        });

        // Avoid paying for data that you don't need by restricting the set of
        // place fields that are returned to just the address components.
        autocomplete.current.setFields(['address_component']);

        // When the user selects an address from the drop-down, populate the
        // address fields in the form.
        autocomplete.current.addListener('place_changed', fillInAddress);
    }

    function initAutocomplete1() {
        // Create the autocomplete object, restricting the search predictions to
        // geographical location types.
        autocomplete1.current = new window.google.maps.places.Autocomplete(document.getElementById('autocomplete1') as HTMLInputElement, {
            types: ['geocode'],
        });

        // Avoid paying for data that you don't need by restricting the set of
        // place fields that are returned to just the address components.
        autocomplete1.current.setFields(['address_component']);

        // When the user selects an address from the drop-down, populate the
        // address fields in the form.
        autocomplete1.current.addListener('place_changed', fillInAddress1);
    }

    const addressRef = useRef<HTMLInputElement>();
    useEffect(() => {
        initAutocomplete();
    }, [addressRef.current]); // eslint-disable-line react-hooks/exhaustive-deps

    const address1Ref = useRef<HTMLInputElement>();
    useEffect(() => {
        initAutocomplete1();
    }, [address1Ref.current]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (newDealState && Users && newDealState.contractCompany) {
            Users?.contacts?.map((person: any) => {
                let fullname = `${person.firstName ? person.firstName : ''} ${person.lastName ? person.lastName : ''}`;
                if (fullname === newDealState.contractCompany) {
                    setNewCompanyContact(person.contactCode);
                }
            });

            // let user = Users?.contacts?.find(
            //     (person: any) => `${person.firstName ? person.firstName : ''} ${person.lastName ? person.lastName : ''}` === newDealState.contractCompany
            // );
        }
    }, [newDealState]); // eslint-disable-line

    const getContactName = (contact: User): string => {
        const company = contact.companyName || contact.name;
        const name = `${contact.firstName} ${contact.lastName}`.trim();
        if (!name && !company) {
            return '...';
        }
        if (contact.contactType === 0) {
            return name || '...';
        }
        if (!name) {
            return company;
        }
        if (!company) {
            return name;
        }
        return [company, name].join(' - ');
    };

    const getCompanyName = (contact: User): string => {
        const company = contact.companyName || contact.name;
        const name = `${contact.firstName} ${contact.lastName}`.trim();
        if (!name && !company) {
            return '...';
        }
        if (contact.contactType === 0) {
            return name || '...';
        }
        if (!name) {
            return company;
        }
        if (!company) {
            return name;
        }
        return company;
    };

    const uploadImageUser = (e: any) => {
        const files = e.target.files;
        const newFile = files[0];
        if (newFile) {
            setImageFileUser(newFile);
        }
    };

    const uploadImageCompany = (e: any) => {
        const files = e.target.files;
        const newFile = files[0];
        if (newFile) {
            setImageFileCompany(newFile);
        }
    };

    return (
        <Box className={css.module}>
            <Box className={css.wrapper}>
                <Paper square elevation={0} className={classNames(css.paper, css.header)}>
                    <Typography align={'left'} variant={'h5'}>
                        {newDealState?.contractTitle}
                    </Typography>
                </Paper>
                <Grid container className={css.infoContainer}>
                    <Grid item xs>
                        <Typography className={classNames(css.infoTitle)}>Buyer</Typography>
                    </Grid>
                    <Grid item xs={1} />
                    <Grid item xs className={css.infoItemContainer}>
                        <Typography className={classNames(css.infoTitle)}>Seller</Typography>
                    </Grid>
                </Grid>
                {!isEditForm && <VerticalPopver childClassName={css.verticalPopver} actionsList={`edit`} onClickEdit={editContactForm} />}
                <form className={css.form} onSubmit={formSubmit}>
                    <Grid container spacing={3} className={css.moduleinner}>
                        <Grid item xs={12}>
                            <Paper square elevation={0} className={css.paper}>
                                <Grid container spacing={3} className={isReverse ? css.reverseContainer : ''}>
                                    <Grid item xs>
                                        {isEditForm ? (
                                            <>
                                                <Typography align={'left'} gutterBottom className={css.infoNameTitle}>
                                                    Legal Entity
                                                </Typography>
                                                <CreatableSelect
                                                    styles={customStyles}
                                                    className={css.selectcustom}
                                                    value={{
                                                        label: legalEntityData.name,
                                                        value: legalEntityData.name,
                                                        id: newDealState?.legalEntityId,
                                                    }}
                                                    onChange={(val: any) => {
                                                        if (val) {
                                                            // let userDetail = val.value.split('-');
                                                            let index = legalUserList.findIndex((person: any) => person.userId === val.id);
                                                            // let firstname = legalUserList[index]?.firstName || (val.value && val.value.split(' ').slice(0, -1).join(' '));
                                                            // let lastname = legalUserList[index]?.lastName || (val.value && val.value.split(' ').slice(-1).join(' '));
                                                            //setNewLegalEntity(checkUserExist(`${firstname} ${lastname}`));
                                                            if (val.__isNew__) {
                                                                setValue('nameforUser', '');
                                                                // setValue('contractFirstforUser', '');
                                                                // setValue('contractLastforUser', '');
                                                                setValue('address1forUser', '');
                                                                setValue('legalCompany', val.value || '');
                                                                setValue('address2forUser', '');
                                                                setValue('address3forUser', '');
                                                                setValue('address4forUser', '');
                                                                setValue('contractTelephoneforUser', '');
                                                                // setValue('contractEmailforUser', '');
                                                                setValue('contractPostCodeforUser', '');
                                                            } else {
                                                                setNewLegalEntity(legalUserList[index]?.contactCode);
                                                            }
                                                            setLegalEntityData({
                                                                name: val.value,
                                                                image: legalUserList[index]?.image || '',
                                                            });
                                                            setValue('nameforUser', val.value);
                                                            setValue('address1forUser', legalUserList[index]?.address || '');
                                                            setValue('legalCompany', legalUserList[index]?.companyName || (val.__isNew__ ? val.value : ''));
                                                            setValue('address2forUser', legalUserList[index]?.route || '');
                                                            setValue('address3forUser', legalUserList[index]?.cityName || '');
                                                            setValue('address4forUser', legalUserList[index]?.countryName || '');
                                                            setValue('contractTelephoneforUser', legalUserList[index]?.phone || '');
                                                            setValue('contractEmailforUser', legalUserList[index]?.email || '');
                                                            // let userName = val.value.split(' ');
                                                            setValue('contractFirstforUser', legalUserList[index]?.firstName || '');
                                                            setValue('contractPostCodeforUser', legalUserList[index]?.zipCode || '');
                                                            setValue('contractLastforUser', legalUserList[index]?.lastName || '');
                                                            setValue('konAddIdforUser', legalUserList[index]?.konAddId || '');
                                                            setValue('isNewEntry', val.__isNew__ ? true : false);
                                                        }
                                                    }}
                                                    options={
                                                        legalUserList &&
                                                        legalUserList.map(u => ({
                                                            label: getContactName(u), //`${(u.companyName || u.name) ? `${u.companyName || u.name} - ` : ''}${u.firstName} ${u.lastName}`,
                                                            value: getContactName(u), //`${(u.companyName || u.name) ? `${u.companyName || u.name} - ` : ''}${u.firstName} ${u.lastName}`,
                                                            id: u.userId,
                                                        }))
                                                    }
                                                />
                                            </>
                                        ) : (
                                            <ProfileInput
                                                name=""
                                                label="Legal Entity"
                                                value={legalEntityData?.name}
                                                isPadding={false}
                                                elementFocus={elementFocus}
                                                updateData={updateData}
                                                isDisabled={true}
                                            />
                                        )}
                                    </Grid>
                                    <Grid item xs={1} className={css.reversContainer}>
                                        <SwapHorizIcon className={css.iconRevers} onClick={() => setIsReverse(!isReverse)}/>
                                    </Grid>
                                    <Grid item xs>
                                        {isEditForm ? (
                                            <>
                                                <Typography align={'left'} gutterBottom className={css.infoNameTitle}>
                                                    Company Name
                                                </Typography>
                                                <Box display="flex">
                                                    <CreatableSelect
                                                        styles={customStyles}
                                                        className={css.selectcustom}
                                                        value={{
                                                            label: companyEntityData.dealCompany,
                                                            value: companyEntityData.dealCompany,
                                                            id: newDealState?.companyContactId,
                                                        }}
                                                        onChange={(val: any) => {
                                                            if (val) {
                                                                // let userDetail = val.value.split('-');
                                                                let index = companyUserList.findIndex((person: any) => person.userId === val.id);

                                                                // let firstname = companyUserList[index]?.firstName || (val.value && val.value.split(' ').slice(0, -1).join(' '));
                                                                // let lastname = companyUserList[index]?.lastName || (val.value && val.value.split(' ').slice(-1).join(' '));
                                                                if (val.__isNew__) {
                                                                    setValue('name', '');
                                                                    setValue('dealCompany', '');
                                                                    setValue('companyName', val.value || '');
                                                                    setValue('address1', '');
                                                                    setValue('address2', '');
                                                                    setValue('address3', '');
                                                                    setValue('address4', '');
                                                                    setValue('contractTelephone', '');
                                                                    setValue('contractEmail', '');
                                                                    setValue('contractFirst', '');
                                                                    setValue('contractLast', '');
                                                                    setValue('contractPostCode', '');
                                                                } else {
                                                                    setNewCompanyContact(companyUserList[index]?.contactCode);
                                                                }
                                                                setCompanyEntityData({
                                                                    image: companyUserList[index]?.image,
                                                                    name: val.value,
                                                                    dealCompany: val.value,
                                                                });
                                                                setValue('name', val.value);
                                                                setValue('dealCompany', val.value);
                                                                setValue(
                                                                    'companyName',
                                                                    companyUserList[index]?.companyName || (val.__isNew__ ? val.value : '')
                                                                );
                                                                setValue('address1', companyUserList[index]?.address || '');
                                                                setValue('address2', companyUserList[index]?.route || '');
                                                                setValue('address3', companyUserList[index]?.cityName || '');
                                                                setValue('address4', companyUserList[index]?.countryName || '');
                                                                setValue('contractTelephone', companyUserList[index]?.phone || '');
                                                                setValue('contractEmail', companyUserList[index]?.email || '');
                                                                setValue('contractFirst', companyUserList[index]?.firstName || '');

                                                                setValue('contractPostCode', companyUserList[index]?.zipCode || '');
                                                                setValue('contractLast', companyUserList[index]?.lastName || '');
                                                                setValue('konAddId', companyUserList[index]?.konAddId || '');
                                                                setValue('companyNewEntry', val.__isNew__ ? true : false);
                                                            }
                                                        }}
                                                        options={
                                                            companyUserList &&
                                                            companyUserList.map(u => ({
                                                                label: `${u.companyName || u.name ? `${u.companyName || u.name} - ` : ''}${u.firstName} ${
                                                                    u.lastName
                                                                }`,
                                                                value: `${u.companyName || u.name ? `${u.companyName || u.name} - ` : ''}${u.firstName} ${
                                                                    u.lastName
                                                                }`,
                                                                id: u.userId,
                                                            }))
                                                        }
                                                    />
                                                    <Button
                                                        variant="contained"
                                                        component="span"
                                                        className={css.clearbtn}
                                                        onClick={() => {
                                                            resetFormLegal();
                                                            resetForm();
                                                        }}
                                                    >
                                                        Clear
                                                    </Button>
                                                </Box>
                                            </>
                                        ) : (
                                            <ProfileInput
                                                name=""
                                                label="Company Name"
                                                value={companyEntityData?.name}
                                                isPadding={false}
                                                elementFocus={elementFocus}
                                                updateData={updateData}
                                                isDisabled={true}
                                            />
                                        )}
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>

                        <Grid item xs={12}>
                            <Paper square elevation={0} className={css.paper}>
                                <Grid container spacing={3} className={isReverse ? css.reverseContainer : ''}>
                                    <Grid item xs>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12}>
                                                <Grid container>
                                                    <Grid item xs className={css.infoAvatarAddress}>
                                                        <Box display="flex" justifyContent="center">
                                                            {imageFileUser ? (
                                                                <Avatar
                                                                    alt={legalEntityData.name}
                                                                    src={URL.createObjectURL(imageFileUser)}
                                                                    className={css.avatar}
                                                                    variant="square"
                                                                />
                                                            ) : (
                                                                <Avatar
                                                                    alt={legalEntityData.name}
                                                                    src={legalEntityData.image}
                                                                    className={css.avatar}
                                                                    variant="square"
                                                                />
                                                            )}
                                                        </Box>

                                                        <div className={isEditForm ? css.inputLabel : css.hidden}>
                                                            <input
                                                                type="file"
                                                                name="imageUser"
                                                                accept=".jpg, .jpeg, .png"
                                                                ref={register}
                                                                id="imageUserFile"
                                                                className={css.inputFile}
                                                                onChange={e => {
                                                                    uploadImageUser(e);
                                                                }}
                                                            />
                                                            <label htmlFor="imageUserFile">Add Photo</label>
                                                        </div>
                                                    </Grid>

                                                    <Grid item xs>
                                                        <Paper square elevation={0} className={css.paperAddress}>
                                                            {!isUserEditAddress && (
                                                                <>
                                                                    {!isEditForm && <EditIcon className={css.iconAddressEdit} onClick={editAddressForm} />}

                                                                    <Grid container>
                                                                        <Grid item xs className={css.infoContainerTextAddress}>
                                                                            <Typography className={classNames(css.infoTextAddress)}>Street:</Typography>
                                                                        </Grid>
                                                                        <Grid item xs>
                                                                            <Typography className={classNames(css.infoTextAddress)}>
                                                                                {getValues('address1forUser')}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid container>
                                                                        <Grid item xs className={css.infoContainerTextAddress}>
                                                                            <Typography className={classNames(css.infoTextAddress)}>City:</Typography>
                                                                        </Grid>
                                                                        <Grid item xs>
                                                                            <Typography className={classNames(css.infoTextAddress)}>
                                                                                {getValues('address2forUser')}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid container>
                                                                        <Grid item xs className={css.infoContainerTextAddress}>
                                                                            <Typography className={classNames(css.infoTextAddress)}>State/County:</Typography>
                                                                        </Grid>
                                                                        <Grid item xs>
                                                                            <Typography className={classNames(css.infoTextAddress)}>
                                                                                {getValues('address3forUser')}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid container>
                                                                        <Grid item xs className={css.infoContainerTextAddress}>
                                                                            <Typography className={classNames(css.infoTextAddress)}>Zip Code:</Typography>
                                                                        </Grid>
                                                                        <Grid item xs>
                                                                            <Typography className={classNames(css.infoTextAddress)}>
                                                                                {getValues('contractPostCodeforUser')}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid container>
                                                                        <Grid item xs className={css.infoContainerTextAddress}>
                                                                            <Typography className={classNames(css.infoTextAddress)}>Country:</Typography>
                                                                        </Grid>
                                                                        <Grid item xs>
                                                                            <Typography className={classNames(css.infoTextAddress)}>
                                                                                {getValues('address4forUser')}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid container>
                                                                        <Grid item xs className={css.infoContainerTextAddress}>
                                                                            <Typography className={classNames(css.infoTextAddress)}>Phone:</Typography>
                                                                        </Grid>
                                                                        <Grid item xs>
                                                                            <Typography className={classNames(css.infoTextAddress)}>
                                                                                {getValues('contractTelephoneforUser')}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                </>
                                                            )}

                                                            <Grid container className={isUserEditAddress ? '' : css.hidden}>
                                                                <Grid item xs={12}>
                                                                    <DealInput
                                                                        id="autocompleteforUser"
                                                                        name="autocompleteforUser"
                                                                        label="Pick Address"
                                                                        value=""
                                                                        isPadding={false}
                                                                        elementFocus={elementFocus}
                                                                        updateData={updateData}
                                                                        isDisabled={false}
                                                                        inputRef={(ref: any) => {
                                                                            addressRef.current = ref;
                                                                            register(ref);
                                                                        }}
                                                                        inputLabelProps={{ shrink: true }}
                                                                        error={''}
                                                                        helperText={''}
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={6} className={css.paddingRight}>
                                                                    <DealInput
                                                                        id="route"
                                                                        name="address1forUser"
                                                                        label="Street"
                                                                        value=""
                                                                        isPadding={false}
                                                                        elementFocus={elementFocus}
                                                                        updateData={updateData}
                                                                        isDisabled={false}
                                                                        inputRef={register}
                                                                        inputLabelProps={{ shrink: true }}
                                                                        error={''}
                                                                        helperText={''}
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={6} className={css.paddingLeft}>
                                                                    <DealInput
                                                                        id="locality"
                                                                        name="address2forUser"
                                                                        label="City"
                                                                        value=""
                                                                        isPadding={false}
                                                                        elementFocus={elementFocus}
                                                                        updateData={updateData}
                                                                        isDisabled={false}
                                                                        inputRef={register}
                                                                        inputLabelProps={{ shrink: true }}
                                                                        error={''}
                                                                        helperText={''}
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={6} className={css.paddingRight}>
                                                                    <DealInput
                                                                        id="state"
                                                                        name="address3forUser"
                                                                        label="State/County"
                                                                        value=""
                                                                        isPadding={false}
                                                                        elementFocus={elementFocus}
                                                                        updateData={updateData}
                                                                        isDisabled={false}
                                                                        inputRef={register}
                                                                        inputLabelProps={{ shrink: true }}
                                                                        error={''}
                                                                        helperText={''}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={6} className={css.paddingRight}>
                                                                    <DealInput
                                                                        id="postal_code"
                                                                        name="contractPostCodeforUser"
                                                                        label="Zip Code"
                                                                        value=""
                                                                        isPadding={false}
                                                                        elementFocus={elementFocus}
                                                                        updateData={updateData}
                                                                        isDisabled={false}
                                                                        inputRef={register}
                                                                        inputLabelProps={{ shrink: true }}
                                                                        error={''}
                                                                        helperText={''}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={6} className={css.paddingLeft}>
                                                                    <DealInput
                                                                        id="country"
                                                                        name="address4forUser"
                                                                        label="Country"
                                                                        value=""
                                                                        isPadding={false}
                                                                        elementFocus={elementFocus}
                                                                        updateData={updateData}
                                                                        isDisabled={false}
                                                                        inputRef={register}
                                                                        inputLabelProps={{ shrink: true }}
                                                                        error={''}
                                                                        helperText={''}
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={6} className={css.paddingLeft}>
                                                                    <Typography className={classNames(css.bold, css.infoTitlePhone)}>Phone</Typography>
                                                                    <Controller
                                                                        render={(props: any) => (
                                                                            <div>
                                                                                <PhoneInput
                                                                                    country={countryCodeForUser.toLowerCase() || 'us'}
                                                                                    value={props.value}
                                                                                    specialLabel={''}
                                                                                    // containerStyle={{ margin: '1rem 0' }}
                                                                                    inputStyle={{
                                                                                        width: '100%',
                                                                                        borderRadius: '8px',
                                                                                        backgroundColor: '#f3f3f3',
                                                                                        fontSize: '14px',
                                                                                        border: '1px solid #CACACA',
                                                                                        padding: '16px 10px 16px 58px',
                                                                                    }}
                                                                                    onChange={(e: any, data: any) => {
                                                                                        props.onChange(e);
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        )}
                                                                        name={'contractTelephoneforUser'}
                                                                        control={control}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Paper>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            {isUserEditAddress && (
                                                <Grid item xs={12}>
                                                    <Button variant="contained" className={css.submitBtn} onClick={cancelAddressForm}>
                                                        Save
                                                    </Button>
                                                    <Button variant="contained" className={css.cancelFormBtn} onClick={cancelAddressForm}>
                                                        Cancel
                                                    </Button>
                                                </Grid>
                                            )}

                                            <Grid item xs={6} className={isEditForm ? css.hidden : ''}>
                                                <ProfileInput
                                                    name=""
                                                    label="Name"
                                                    value={`${getValues('contractFirstforUser')} ${getValues('contractLastforUser')}`.trim()}
                                                    isPadding={false}
                                                    elementFocus={elementFocus}
                                                    updateData={updateData}
                                                    isDisabled={!isEditForm}
                                                />
                                            </Grid>

                                            <Grid item xs={6} className={isEditForm ? '' : css.hidden}>
                                                <DealInput
                                                    id=""
                                                    name="contractFirstforUser"
                                                    label="First Name"
                                                    value=""
                                                    isPadding={false}
                                                    elementFocus={elementFocus}
                                                    updateData={updateData}
                                                    isDisabled={!isEditForm}
                                                    inputRef={register}
                                                    inputLabelProps={{ shrink: true }}
                                                    error={''}
                                                    helperText={''}
                                                />
                                            </Grid>
                                            <Grid item xs={6} className={isEditForm ? '' : css.hidden}>
                                                <DealInput
                                                    id=""
                                                    name="contractLastforUser"
                                                    label="Last Name"
                                                    value=""
                                                    isPadding={false}
                                                    elementFocus={elementFocus}
                                                    updateData={updateData}
                                                    isDisabled={!isEditForm}
                                                    inputRef={register}
                                                    inputLabelProps={{ shrink: true }}
                                                    error={''}
                                                    helperText={''}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <DealInput
                                                    id=""
                                                    name="contractEmailforUser"
                                                    label="Email"
                                                    value=""
                                                    isPadding={false}
                                                    elementFocus={elementFocus}
                                                    updateData={updateData}
                                                    isDisabled={!isEditForm}
                                                    inputRef={register({
                                                        pattern: {
                                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                            message: 'Invalid email address',
                                                        },
                                                    })}
                                                    inputLabelProps={{ shrink: true }}
                                                    error={!!errors.contractEmailforUser}
                                                    helperText={errors.contractEmailforUser?.message}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={1} />
                                    <Grid item xs>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12}>
                                                <Grid container>
                                                    <Grid item xs className={css.infoAvatarAddress}>
                                                        <Box display="flex" justifyContent="center">
                                                            {imageFileCompany ? (
                                                                <Avatar
                                                                    alt={companyEntityData.name}
                                                                    src={URL.createObjectURL(imageFileCompany)}
                                                                    className={css.avatar}
                                                                    variant="square"
                                                                />
                                                            ) : (
                                                                <Avatar
                                                                    alt={companyEntityData.name}
                                                                    src={companyEntityData.image}
                                                                    className={css.avatar}
                                                                    variant="square"
                                                                />
                                                            )}
                                                        </Box>

                                                        <div className={isEditForm ? css.inputLabel : css.hidden}>
                                                            <input
                                                                type="file"
                                                                name="imageCompany"
                                                                accept=".jpg, .jpeg, .png"
                                                                ref={register}
                                                                id="imageFileCompany"
                                                                className={css.inputFile}
                                                                onChange={e => {
                                                                    uploadImageCompany(e);
                                                                }}
                                                            />
                                                            <label htmlFor="imageFileCompany">Add Photo</label>
                                                        </div>
                                                    </Grid>

                                                    <Grid item xs>
                                                        <Paper square elevation={0} className={css.paperAddress}>
                                                            {!isCompanyEditAddress && (
                                                                <>
                                                                    {!isEditForm && (
                                                                        <EditIcon className={css.iconAddressEdit} onClick={editCompanyAddressForm} />
                                                                    )}

                                                                    <Grid container>
                                                                        <Grid item xs className={css.infoContainerTextAddress}>
                                                                            <Typography className={classNames(css.infoTextAddress)}>Street:</Typography>
                                                                        </Grid>
                                                                        <Grid item xs>
                                                                            <Typography className={classNames(css.infoTextAddress)}>
                                                                                {getValues('address1')}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid container>
                                                                        <Grid item xs className={css.infoContainerTextAddress}>
                                                                            <Typography className={classNames(css.infoTextAddress)}>City:</Typography>
                                                                        </Grid>
                                                                        <Grid item xs>
                                                                            <Typography className={classNames(css.infoTextAddress)}>
                                                                                {getValues('address2')}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid container>
                                                                        <Grid item xs className={css.infoContainerTextAddress}>
                                                                            <Typography className={classNames(css.infoTextAddress)}>State/County:</Typography>
                                                                        </Grid>
                                                                        <Grid item xs>
                                                                            <Typography className={classNames(css.infoTextAddress)}>
                                                                                {getValues('address3')}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>

                                                                    <Grid container>
                                                                        <Grid item xs className={css.infoContainerTextAddress}>
                                                                            <Typography className={classNames(css.infoTextAddress)}>Zip Code:</Typography>
                                                                        </Grid>
                                                                        <Grid item xs>
                                                                            <Typography className={classNames(css.infoTextAddress)}>
                                                                                {getValues('contractPostCode')}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid container>
                                                                        <Grid item xs className={css.infoContainerTextAddress}>
                                                                            <Typography className={classNames(css.infoTextAddress)}>Country:</Typography>
                                                                        </Grid>
                                                                        <Grid item xs>
                                                                            <Typography className={classNames(css.infoTextAddress)}>
                                                                                {getValues('address4')}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid container>
                                                                        <Grid item xs className={css.infoContainerTextAddress}>
                                                                            <Typography className={classNames(css.infoTextAddress)}>Phone:</Typography>
                                                                        </Grid>
                                                                        <Grid item xs>
                                                                            <Typography className={classNames(css.infoTextAddress)}>
                                                                                {getValues('contractTelephone')}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                </>
                                                            )}

                                                            <Grid container className={isCompanyEditAddress ? '' : css.hidden}>
                                                                <Grid item xs={12}>
                                                                    <DealInput
                                                                        id="autocomplete1"
                                                                        name="autocomplete1"
                                                                        label="Pick Address"
                                                                        value=""
                                                                        isPadding={false}
                                                                        elementFocus={elementFocus}
                                                                        updateData={updateData}
                                                                        isDisabled={false}
                                                                        inputRef={(ref: any) => {
                                                                            address1Ref.current = ref;
                                                                            register(ref);
                                                                        }}
                                                                        inputLabelProps={{ shrink: true }}
                                                                        error={''}
                                                                        helperText={''}
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={6} className={css.paddingRight}>
                                                                    <DealInput
                                                                        id="route2"
                                                                        name="address1"
                                                                        label="Street"
                                                                        value=""
                                                                        isPadding={false}
                                                                        elementFocus={elementFocus}
                                                                        updateData={updateData}
                                                                        isDisabled={false}
                                                                        inputRef={register}
                                                                        inputLabelProps={{ shrink: true }}
                                                                        error={''}
                                                                        helperText={''}
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={6} className={css.paddingLeft}>
                                                                    <DealInput
                                                                        id="locality2"
                                                                        name="address2"
                                                                        label="City"
                                                                        value=""
                                                                        isPadding={false}
                                                                        elementFocus={elementFocus}
                                                                        updateData={updateData}
                                                                        isDisabled={false}
                                                                        inputRef={register}
                                                                        inputLabelProps={{ shrink: true }}
                                                                        error={''}
                                                                        helperText={''}
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={6} className={css.paddingRight}>
                                                                    <DealInput
                                                                        id="state2"
                                                                        name="address3"
                                                                        label="State/County"
                                                                        value=""
                                                                        isPadding={false}
                                                                        elementFocus={elementFocus}
                                                                        updateData={updateData}
                                                                        isDisabled={false}
                                                                        inputRef={register}
                                                                        inputLabelProps={{ shrink: true }}
                                                                        error={''}
                                                                        helperText={''}
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={6} className={css.paddingRight}>
                                                                    <DealInput
                                                                        id="postal_code2"
                                                                        name="contractPostCode"
                                                                        label="Zip Code"
                                                                        value=""
                                                                        isPadding={false}
                                                                        elementFocus={elementFocus}
                                                                        updateData={updateData}
                                                                        isDisabled={false}
                                                                        inputRef={register}
                                                                        inputLabelProps={{ shrink: true }}
                                                                        error={''}
                                                                        helperText={''}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={6} className={css.paddingLeft}>
                                                                    <DealInput
                                                                        id="country2"
                                                                        name="address4"
                                                                        label="Country"
                                                                        value=""
                                                                        isPadding={false}
                                                                        elementFocus={elementFocus}
                                                                        updateData={updateData}
                                                                        isDisabled={false}
                                                                        inputRef={register}
                                                                        inputLabelProps={{ shrink: true }}
                                                                        error={''}
                                                                        helperText={''}
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={6} className={css.paddingLeft}>
                                                                    <Typography className={classNames(css.bold, css.infoTitlePhone)}>Phone</Typography>
                                                                    <Controller
                                                                        render={(props: any) => (
                                                                            <div>
                                                                                <PhoneInput
                                                                                    country={countryCode.toLowerCase() || 'us'}
                                                                                    value={props.value}
                                                                                    specialLabel={''}
                                                                                    // containerStyle={{ margin: '1rem 0' }}
                                                                                    inputStyle={{
                                                                                        width: '100%',
                                                                                        borderRadius: '8px',
                                                                                        backgroundColor: '#f3f3f3',
                                                                                        fontSize: '14px',
                                                                                        border: '1px solid #CACACA',
                                                                                        padding: '16px 10px 16px 58px',
                                                                                    }}
                                                                                    onChange={(e: any, data: any) => {
                                                                                        props.onChange(e);
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        )}
                                                                        name={'contractTelephone'}
                                                                        control={control}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Paper>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            {isCompanyEditAddress && (
                                                <Grid item xs={12}>
                                                    <Button variant="contained" className={css.submitBtn} onClick={cancelCompanyAddressForm}>
                                                        Save
                                                    </Button>
                                                    <Button variant="contained" className={css.cancelFormBtn} onClick={cancelCompanyAddressForm}>
                                                        Cancel
                                                    </Button>
                                                </Grid>
                                            )}

                                            <Grid item xs={6} className={isEditForm ? css.hidden : ''}>
                                                <ProfileInput
                                                    name=""
                                                    label="Name"
                                                    value={`${getValues('contractFirst')} ${getValues('contractLast')}`.trim()}
                                                    isPadding={false}
                                                    elementFocus={elementFocus}
                                                    updateData={updateData}
                                                    isDisabled={!isEditForm}
                                                />
                                            </Grid>

                                            <Grid item xs={6} className={isEditForm ? '' : css.hidden}>
                                                <DealInput
                                                    id=""
                                                    name="contractFirst"
                                                    label="First Name"
                                                    value=""
                                                    isPadding={false}
                                                    elementFocus={elementFocus}
                                                    updateData={updateData}
                                                    isDisabled={!isEditForm}
                                                    inputRef={register}
                                                    inputLabelProps={{ shrink: true }}
                                                    error={''}
                                                    helperText={''}
                                                />
                                            </Grid>
                                            <Grid item xs={6} className={isEditForm ? '' : css.hidden}>
                                                <DealInput
                                                    id=""
                                                    name="contractLast"
                                                    label="Last Name"
                                                    value=""
                                                    isPadding={false}
                                                    elementFocus={elementFocus}
                                                    updateData={updateData}
                                                    isDisabled={!isEditForm}
                                                    inputRef={register}
                                                    inputLabelProps={{ shrink: true }}
                                                    error={''}
                                                    helperText={''}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <DealInput
                                                    id=""
                                                    name="contractEmail"
                                                    label="Email"
                                                    value=""
                                                    isPadding={false}
                                                    elementFocus={elementFocus}
                                                    updateData={updateData}
                                                    isDisabled={!isEditForm}
                                                    inputRef={register({
                                                        pattern: {
                                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                            message: 'Invalid email address',
                                                        },
                                                    })}
                                                    inputLabelProps={{ shrink: true }}
                                                    error={!!errors.contractEmailforUser}
                                                    helperText={errors.contractEmailforUser?.message}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                        <Grid item xs={6}>
                            <div className={css.hidden}>
                                <TextField
                                    inputRef={register}
                                    multiline
                                    rows={1}
                                    fullWidth
                                    // placeholder={'Address'}
                                    name={'gDealId'}
                                    label={'gDealId'}
                                    hidden
                                />
                                <TextField
                                    inputRef={register}
                                    multiline
                                    rows={1}
                                    fullWidth
                                    // placeholder={'Address'}
                                    name={'isNewEntry'}
                                    label={'isNewEntry'}
                                    hidden
                                />
                                <input type="hidden" ref={register} name={'konAddIdforUser'}/>
                                <TextField
                                    inputRef={register}
                                    multiline
                                    rows={1}
                                    fullWidth
                                    // placeholder={'Address'}
                                    name={'nameforUser'}
                                    label={'nameforUser'}
                                    hidden
                                />
                                <Typography align={'left'} variant={'h6'} className={css.companyname} style={{ marginTop: '-10px' }}>
                                    Company
                                </Typography>
                                <TextField
                                    inputRef={register}
                                    fullWidth
                                    // placeholder={'Address'}
                                    name={'legalCompany'}
                                    label={''}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div className={css.hidden}>
                                <TextField
                                    inputRef={register}
                                    multiline
                                    rows={1}
                                    fullWidth
                                    // placeholder={'Address'}
                                    name={'companyNewEntry'}
                                    label={'Address'}
                                    hidden
                                />
                                <input type="hidden" ref={register} name={'konAddId'} />
                                <TextField
                                    inputRef={register}
                                    multiline
                                    rows={1}
                                    fullWidth
                                    // placeholder={'Address'}
                                    name={'с'}
                                    label={'Company'}
                                    hidden
                                />
                                <Typography align={'left'} variant={'h6'} className={css.companyname} style={{ marginTop: '10px' }}>
                                    Company
                                </Typography>
                                <TextField
                                    inputRef={register}
                                    fullWidth
                                    // placeholder={'Address'}
                                    name={'companyName'}
                                    label={''}
                                />
                            </div>
                        </Grid>
                    </Grid>
                    {isEditForm ? (
                        <Grid container>
                            <Grid item xs={12}>
                                <Button variant="contained" className={css.submitFormBtn} onClick={cancelForm}>
                                    Save
                                </Button>
                                <Button variant="contained" className={css.cancelFormBtn} onClick={cancelForm}>
                                    Cancel
                                </Button>
                            </Grid>
                        </Grid>
                    ) : (
                        (!isUserEditAddress || !isCompanyEditAddress) && <StepControls onPrevClick={prevStep} errors={errors} />
                    )}
                </form>
            </Box>
        </Box>
    );
};
const customStyles = {
    menu: (provided: any, state: any) => ({
        ...provided,
        zIndex: '9999',
    }),
};
